import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=cbf1c24a&scoped=true"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"
import style0 from "./Option.vue?vue&type=style&index=0&id=cbf1c24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf1c24a",
  null
  
)

export default component.exports